import "./aboutus.css";
import { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const AboutUs = () => {
  const { t } = useContext(LanguageContext);

  useEffect(() => {
  const reveals = document.querySelectorAll(".reveal");

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    },
    { threshold: 0.15 }
  );

  reveals.forEach(el => observer.observe(el));

  return () => observer.disconnect();
}, []);

  return (
    <div className="about-container">
      {/* Hero / Banner Section */}
      <div className="about-hero">
        <div className="overlay">
          <h1>{t("navbar.menu.AboutUs")}</h1>
          <p>{t("aboutUs.imageDescription")}</p>
        </div>
      </div>

      {/* Story Section */}
      <div className="about-story reveal">
        <h2>{t("aboutUs.ourStory")}</h2>
        <p>{t("aboutUs.ourStoryDetails")}</p>
        <p>{t("aboutUs.outStoryDetails2")}</p>
      </div>

      {/* Mission & Vision */}
      <div className="mission-vision reveal">
        <div className="card">
          <h3>{t("aboutUs.ourMission")}</h3>
          <p>{t("aboutUs.ourMissionDetails")}</p>
        </div>
        <div className="card">
          <h3>{t("aboutUs.ourVision")}</h3>
          <p>{t("aboutUs.ourVisionDetails")}</p>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="why-choose reveal">
        <h2>{t("aboutUs.whyChooseUs")}</h2>
        <div className="features">
          <div className="feature">
            <h4>🪨 {t("aboutUs.authenticStone")}</h4>
            <p>{t("aboutUs.authenticStoneDetails")}</p>
          </div>
          <div className="feature">
            <h4>🎨 {t("aboutUs.handcraftedArt")}</h4>
            <p>{t("aboutUs.handcraftedArtDetails")}</p>
          </div>
          <div className="feature">
            <h4>🌍 {t("aboutUs.globalReach")}</h4>
            <p>{t("aboutUs.globalReachDetails")}</p>
          </div>
        </div>
      </div>
      {/* Jaipur about-store */}
      <div className="about-store reveal">
        <div className="about-store-info">
          <h3>{t("aboutUs.jaipurStore")}</h3>
          <p>{t("aboutUs.storeAddress")}</p>
          <p className="about-store-phone">{t("aboutUs.storeContactPhone")}</p>
          <p className="about-store-phone">{t("aboutUs.storeContactEmail")}</p>
          <p>{t("aboutUs.storeHours")}</p>
        </div>
        <div className="about-store-map">
          <iframe
            title="Shri Hari Om Moorti Bhandar"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.1257612963733!2d75.81266207504172!3d26.923385776657083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4b20b944839f%3A0xc8fe880c2dcecf71!2sShri%20Hari%20Om%20Moorti%20Bhandar%2C%20Jaipur!5e0!3m2!1sen!2sin!4v1727209500000!5m2!1sen!2sin"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      {/* Jaipur Wareshouse */}
      <div className="about-store">
        <div className="about-store-info">
          <h3>{t("aboutUs.jaipurWarehouse")}</h3>
          <p>{t("aboutUs.warehouseAddress")}</p>
          <p className="about-store-phone">{t("aboutUs.storeContactPhone")}</p>
          <p className="about-store-phone">{t("aboutUs.storeContactEmail")}</p>
          <p>{t("aboutUs.storeHours")}</p>
        </div>
        <div className="about-store-map">
          <iframe
            title="Shri Hari Om Moorti Bhandar"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.1257612963733!2d75.81266207504172!3d26.923385776657083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4b20b944839f%3A0xc8fe880c2dcecf71!2sShri%20Hari%20Om%20Moorti%20Bhandar%2C%20Jaipur!5e0!3m2!1sen!2sin!4v1727209500000!5m2!1sen!2sin"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
